// extracted by mini-css-extract-plugin
module.exports = {"card":"ContactPage_card__1O9np"};